import ReportedHolrbacksTable from './ReportedHolrbacksTable';

export default ReportedHolrbacksTable;
